/* LP Immun-Routine: Paket-Wähler, Top-Bar-Countdown, shopweites Rating aus dem REVIEWS.io Rating-Bar-Widget.
   Vanilla JS, keine globalen Variablen, Custom Elements nur einmal registriert. */
(function () {
  'use strict';

  /* Paket-Wähler: schaltet Panels (Theme-Produktformular), Visual und Rating per data-ir-package um. */
  if (!customElements.get('ir-package-switch')) {
    customElements.define('ir-package-switch', class extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-ir-package-btn]'));
        this.buttons.forEach((btn) => {
          btn.addEventListener('click', () => this.select(btn.dataset.irPackageBtn));
        });
      }

      select(key) {
        this.buttons.forEach((btn) => {
          const on = btn.dataset.irPackageBtn === key;
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.classList.toggle('is-sel', on);
        });
        this.querySelectorAll('[data-ir-package]').forEach((el) => {
          el.hidden = el.dataset.irPackage !== key;
        });
      }
    });
  }

  /* Top Bar: Variante B zählt gegen data-end herunter; leer, ungültig oder abgelaufen = Variante A. */
  if (!customElements.get('ir-topbar')) {
    customElements.define('ir-topbar', class extends HTMLElement {
      connectedCallback() {
        this.promo = this.querySelector('[data-ir-topbar-promo]');
        this.saison = this.querySelector('[data-ir-topbar-saison]');
        if (!this.promo) return;
        this.end = Date.parse(this.dataset.end || '');
        this.hh = this.promo.querySelector('[data-ir-cd="h"]');
        this.mm = this.promo.querySelector('[data-ir-cd="m"]');
        this.ss = this.promo.querySelector('[data-ir-cd="s"]');
        this.tick();
        if (!this.expired) this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      tick() {
        const diff = Math.floor((this.end - Date.now()) / 1000);
        if (!Number.isFinite(diff) || diff <= 0) {
          this.expired = true;
          if (this.timer) clearInterval(this.timer);
          this.promo.hidden = true;
          if (this.saison) this.saison.hidden = false;
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        if (this.hh) this.hh.textContent = pad(Math.floor(diff / 3600));
        if (this.mm) this.mm.textContent = pad(Math.floor((diff % 3600) / 60));
        if (this.ss) this.ss.textContent = pad(diff % 60);
        this.promo.hidden = false;
        if (this.saison) this.saison.hidden = true;
      }
    });
  }

  /* Shopweites Rating: gleiche Auslese wie sections/s-sec-social-proof.liquid. */
  function formatCount(raw) {
    const digits = String(raw).replace(/\D/g, '');
    if (!digits) return '';
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function formatRating(raw) {
    const m = String(raw).match(/\d+(?:[.,]\d+)?/);
    return m ? m[0].replace('.', ',') : '';
  }

  function initShopRating(source) {
    if (source.dataset.irInit) return;
    source.dataset.irInit = '1';
    const root = source.closest('.lp-ir') || document;
    let attempts = 0;
    const run = () => {
      const stats = source.querySelectorAll('.RatingBarWidget .cssVar-reviewStatistics');
      if (stats.length >= 2) {
        const rating = formatRating(stats[0].textContent);
        const count = formatCount(stats[1].textContent);
        if (rating && count) {
          root.querySelectorAll('[data-ir-shop-rating]').forEach((el) => { el.textContent = rating; });
          root.querySelectorAll('[data-ir-shop-count]').forEach((el) => { el.textContent = count; });
          return;
        }
      }
      attempts += 1;
      if (attempts < 80) setTimeout(run, 250);
    };
    run();
  }

  function initAll() {
    document.querySelectorAll('[data-ir-shop-rating-source]').forEach(initShopRating);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
